var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 2.66675H2.66634C1.93301 2.66675 1.33967 3.26675 1.33967 4.00008L1.33301 12.0001C1.33301 12.7334 1.93301 13.3334 2.66634 13.3334H13.333C14.0663 13.3334 14.6663 12.7334 14.6663 12.0001V4.00008C14.6663 3.26675 14.0663 2.66675 13.333 2.66675ZM12.6663 12.0001H3.33301C2.96634 12.0001 2.66634 11.7001 2.66634 11.3334V5.33341L7.29301 8.22675C7.72634 8.50008 8.27301 8.50008 8.70634 8.22675L13.333 5.33341V11.3334C13.333 11.7001 13.033 12.0001 12.6663 12.0001ZM7.99967 7.33341L2.66634 4.00008H13.333L7.99967 7.33341Z",
    fill: "#34443F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOutline);
export default __webpack_public_path__ + "static/media/mail_outline.5f916292e5ad748956a96e3d765af14a.svg";
export { ForwardRef as ReactComponent };